<template>
  <va-action-button :icon="icon" :label="label" text @click="exec(deploymentId)" />
</template>
<script>
import Button from "@skuhnow/vuetify-admin/src/mixins/button";
import admin from "@/plugins/admin";

export default {
  props: ["action", "icon", "label", "deploymentId"],
  mixins: [Button],
  methods: {
    exec(deploymentId) {
      admin.http
        .put(`${process.env.VUE_APP_API_URL}/deployments/${deploymentId}`, {
          action: this.action
        })
        .then(() =>
          this.$store.commit(`messages/showToast`, {
            color: "success",
            message: `Worker action invoked: ${this.action}`
          })
        )
        .catch(() =>
          this.$store.commit(`messages/showToast`, {
            color: "error",
            message: `Error for action: ${this.action}`
          })
        );
    }
  }
};
</script>
